import React from 'react';

const Keyboard = ({ onKeyPress, usedLetters }) => {
  const rows = [
    ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P', 'BACKSPACE'],
    ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'],
    ['ENTER', 'Z', 'X', 'C', 'V', 'B', 'N', 'M']
  ];

  const getKeyColor = (key) => {
    if (!usedLetters[key]) return 'bg-gray-600 hover:bg-gray-500 active:bg-gray-400';
    if (usedLetters[key] === 'correct') return 'bg-green-500 hover:bg-green-600 active:bg-green-700';
    if (usedLetters[key] === 'present') return 'bg-yellow-500 hover:bg-yellow-600 active:bg-yellow-700';
    if (usedLetters[key] === 'absent') return 'bg-gray-700 hover:bg-gray-600 active:bg-gray-500';
    return 'bg-gray-600 hover:bg-gray-500 active:bg-gray-400';
  };

  const handleKeyClick = (key) => {
    if (key === 'ENTER') {
      onKeyPress({ key: 'Enter' });
    } else if (key === 'BACKSPACE') {
      onKeyPress({ key: 'Backspace' });
    } else {
      onKeyPress({ key: key.toLowerCase() });
    }
  };

  return (
    <div className="sticky bottom-0 bg-gray-800 py-2 px-2 sm:px-4 w-full mb-20">
      {rows.map((row, rowIndex) => (
        <div key={rowIndex} className="flex justify-center gap-1 sm:gap-2 mb-2">
          {row.map((key) => (
            <button
              key={key}
              onClick={() => handleKeyClick(key)}
              className={`${getKeyColor(key)} text-white font-bold py-3 sm:py-4 px-2 sm:px-3 rounded text-sm sm:text-base
                ${key === 'ENTER' ? 'w-16 sm:w-20' : key === 'BACKSPACE' ? 'w-10 sm:w-12' : 'w-8 sm:w-10'}
                transition-colors duration-200 touch-manipulation select-none`}
            >
              {key === 'BACKSPACE' ? '⌫' : key}
            </button>
          ))}
        </div>
      ))}
    </div>
  );
};

export default Keyboard; 